import store from '@core/store';

const discoverLocale = async (to, from, next) => {
    await store.dispatch('i18n/getLocale');

    next();
};

export default discoverLocale;
